import { I18n } from '@calendly/i18n'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { TRACKING_EVENT_NAMES } from 'hooks/analytics_events'
import { trackEvent } from 'hooks/analytics_events/useTrack'

import { idSelector } from '../../../selectors/current_user'

export const createCardToken = createAsyncThunk(
  'payment/createCardToken',
  async ({ stripe, elements }, { rejectWithValue, getState }) => {
    const result = await stripe.createToken(elements.getElement('card'))
    if (!result.token) {
      return rejectWithValue(result.error.message)
    }

    const userId = idSelector(getState())
    const countryCode = result.token?.card?.country

    if (result.token?.card?.country === 'US' && !result.token.card.address_zip) {
      return rejectWithValue(I18n.t('publisher.billing.checkout.order.steps.payment_method.require_us_zip_code'))
    }

    if (userId) {
      // Using trackEvent instead of useTrack hook because this is a Redux thunk
      trackEvent({
        name: TRACKING_EVENT_NAMES.PAYMENT_METHOD_DETECTED,
        dependencies: { user_id: userId },
        properties: {
          payment_method: 'credit_card',
          billing_country_captured: countryCode,
          location: 'deal_link_checkout_flow'
        }
      })
    }

    return result.token
  }
)
